/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { oneOffPaymentNoticeGetResponseSchema } from './oneOffPaymentNoticeGetResponseSchema.ts';

export const getOneOffPaymentNoticeQueryParamsSchema = z.object({
  reference: z.string(),
});

/**
 * @description 200 response
 */
export const getOneOffPaymentNotice200Schema = z.lazy(() => oneOffPaymentNoticeGetResponseSchema);

/**
 * @description 505 response
 */
export const getOneOffPaymentNotice505Schema = z.any();

export const getOneOffPaymentNoticeQueryResponseSchema = z.lazy(() => getOneOffPaymentNotice200Schema);
